import { render, staticRenderFns } from "./AddRecipientComponent.vue?vue&type=template&id=56fd1aee&scoped=true&"
import script from "./AddRecipientComponent.vue?vue&type=script&lang=js&"
export * from "./AddRecipientComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddRecipientComponent.vue?vue&type=style&index=0&id=56fd1aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd1aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VCol,VDivider,VIcon,VRow})
